import React from 'react'
import './index.sass'

const SimpleBtn = ({ btnName, onHandleClick, border = false, disabled = false }) => (
  <button
    className={border ? 'simple-btn simple-btn_border subtitle-2' : 'simple-btn subtitle-2'}
		onClick={onHandleClick}
		disabled={disabled}
  >
    {btnName}
  </button>
)

export default SimpleBtn
